import i18n from "i18n";

export const playerMessages = {
  deletePlayer: i18n.t('notifications.player.deletePlayer')
}
